export default from './protected-button';



// WEBPACK FOOTER //
// ./app/containers/protected-button/index.js